export default __webpack_public_path__ + "static/media/cover.5090494d.png";